import { useCallback, useEffect, useRef, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { MoneyInfo, MoneyHeader } from '~/components';
import styles from './Money.module.scss';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { getDay, getMonth } from '~/utils/datetime';
import { useStore } from '~/store';

function Money() {
    const [state] = useStore();
    const { moneys } = state;

    const [total, setTotal] = useState(0);
    const { id: moneyId } = useParams();
    const refActiveMoney = useRef(null);

    const [currentFilter, setCurrentFilter] = useState({
        filterDayMonth: null,
        filterPlace: null,
        filterType: null,
    });
    const checkFilter = useCallback(
        (money) => {
            // console.log('money', money);
            if (currentFilter.filterDayMonth) {
                if (
                    currentFilter.filterDayMonth.day !==
                        getDay(money.datetime) ||
                    currentFilter.filterDayMonth.month !==
                        getMonth(money.datetime)
                )
                    return false;
            }

            if (currentFilter.filterType) {
                if (currentFilter.filterType !== money.type) return false;
            }

            if (currentFilter.filterPlace) {
                if (currentFilter.filterPlace !== money.placeName) return false;
            }
            return true;
        },
        [currentFilter],
    );

    const handleOnCancelFilter = () => {
        console.log('handleOnCancelFilter');
    };

    const handleOnSaveFilter = (filter) => {
        setCurrentFilter({ ...filter });
    };

    const handleOnDeleteSuccess = (id) => {
        // setMoneys((pre) => pre.filter((money) => money.id !== id));
    };

    useEffect(() => {
        let sum = 0;
        moneys.forEach((money) => {
            if (checkFilter(money)) sum += money.amount;
        });
        // console.log('sum', sum);
        setTotal(sum);
    }, [moneys, checkFilter]);

    useEffect(() => {
        if (refActiveMoney && refActiveMoney.current) {
            refActiveMoney.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            });
        }
    });

    return (
        <div className={styles.wrapper}>
            <MoneyHeader
                title={'DANH SÁCH CHI TIÊU'}
                total={total}
                onCancel={handleOnCancelFilter}
                onSave={handleOnSaveFilter}
                currentFilter={currentFilter}
            />

            {total > 0 && (
                <TransitionGroup className={styles.list}>
                    {moneys.map((money) => {
                        return checkFilter(money) ? (
                            <CSSTransition
                                key={money.id}
                                timeout={1000}
                                classNames="item"
                            >
                                {money.id === moneyId ? (
                                    <div ref={refActiveMoney}>
                                        <MoneyInfo
                                            {...money}
                                            onDeleteSuccess={
                                                handleOnDeleteSuccess
                                            }
                                            active
                                        ></MoneyInfo>
                                    </div>
                                ) : (
                                    <div>
                                        <MoneyInfo
                                            {...money}
                                            onDeleteSuccess={
                                                handleOnDeleteSuccess
                                            }
                                        ></MoneyInfo>
                                    </div>
                                )}
                            </CSSTransition>
                        ) : (
                            ''
                        );
                    })}
                </TransitionGroup>
            )}
            {!state.loading && total === 0 && (
                <div className={styles.noMoneyWithFilter}>
                    Không có chi tiêu thỏa điều kiện lọc
                </div>
            )}

            <Link to={`/add`}>
                <div className={styles.topAction}>
                    <i className="fa-solid fa-plus"></i>
                </div>
            </Link>
        </div>
    );
}

export default Money;
